import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';
import AddCategoryModal from '../../components/admin/AddCategoryModal';
import AdminLayout from '../../components/admin/AdminLayout';
import { useNavigate } from 'react-router-dom';
import './Configurations.modules.css';

const Configurations = () => {
    const [categories, setCategories] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const data = await apiService.getCategories();
            setCategories(data);
        } catch (err) {
            setError('Error al cargar las categorías.');
            console.error('Error fetching categories:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddCategory = async (categoryName, imageFile) => {
        try {
            await apiService.createCategory(categoryName, imageFile);
            fetchCategories(); // Refrescar la lista de categorías
            setIsModalOpen(false); // Cerrar el modal
        } catch (err) {
            setError('Error al crear la categoría.');
            console.error('Error creating category:', err);
        }
    };

    const handleDeleteCategory = async (categoryId, categoryName, imageUrl) => {
        if (window.confirm(`¿Estás seguro de que deseas eliminar la categoría "${categoryName}"?`)) {
            try {
                await apiService.deleteCategory(categoryId, imageUrl);
                fetchCategories(); // Refrescar la lista de categorías
            } catch (err) {
                setError('Error al eliminar la categoría.');
                console.error('Error deleting category:', err);
            }
        }
    };

    return (
        <AdminLayout>
            <div className="configurations-container">
                <h1>Configuraciones y Preferencias</h1>
                <button className="back-button" onClick={() => navigate('/admin/dashboard')}>Volver al Dashboard</button>

                <section className="category-management">
                    <h2>Gestión de Categorías</h2>
                    {loading && <p>Cargando categorías...</p>}
                    {error && <p className="error-message">{error}</p>}
                    {!loading && !error && (
                        <>
                            <div className="category-list-small">
                                {categories.length > 0 ? (
                                    <ul>
                                        {categories.map(category => (
                                            <li key={category.id} className="category-item">
                                                <span className="category-name">{category.name}</span>
                                                <button
                                                    className="delete-category-button"
                                                    onClick={() => handleDeleteCategory(category.id, category.name, category.image_url)}
                                                    title="Eliminar categoría"
                                                >
                                                    🗑️
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>No hay categorías disponibles.</p>
                                )}
                            </div>
                            <button className="add-category-button" onClick={() => setIsModalOpen(true)}>
                                Agregar Categoría
                            </button>
                        </>
                    )}
                </section>

                <AddCategoryModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onSave={handleAddCategory}
                />
            </div>
        </AdminLayout>
    );
};

export default Configurations;
